import React, { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

import PropTypes from 'prop-types';

import { useUser } from 'hooks';

import BootGate from '../BootProvider/BootGate';

function GuestGuard(props) {
  const { children } = props;

  // Hooks
  const { search } = useLocation();

  // Custom hooks
  const { isAuthenticated, refreshing } = useUser();

  // Queries
  const prevSearch = new URLSearchParams(search);
  const redirect = prevSearch.get('redirect');
  prevSearch.delete('redirect');
  const newSearch = prevSearch.toString();

  // Effects

  useEffect(() => {
    if (!isAuthenticated || refreshing) return;

    const newRedirect = redirect ? `${redirect}?${newSearch}` : null;
    window.location.href = newRedirect || `/accounts?${newSearch}`;
  }, [isAuthenticated, refreshing, redirect, newSearch]);

  if (isAuthenticated && refreshing) return <BootGate />;
  if (isAuthenticated) return null;

  return children;
}

GuestGuard.propTypes = {
  children: PropTypes.any,
};

export default GuestGuard;
